export const EFFECTIVE_DATE = "June 15, 2026";

export const intro =
  "GrowCalc (\u201cwe\u201d, \u201cus\u201d, or \u201cour\u201d) operates the GrowCalc mobile application (the \u201cApp\u201d). This Privacy Policy explains what information we collect, how we use it, and the choices you have. By using the App, you agree to this policy.";

export const sections = [
  {
    id: "information-we-collect",
    title: "1. Information We Collect",
    items: [
      { label: "Account information", text: "your email address and display name when you create an account or sign in with Google." },
      { label: "Lawn & product data you enter", text: "zones/lawn areas, products and their N-P-K values, calculations, application logs, soil pH readings, reminders, seasons, and any notes you add." },
      { label: "Location input", text: "a U.S. ZIP code you type to fetch local weather and soil temperature. We do NOT collect precise GPS location." },
      { label: "Subscription status", text: "whether you hold an active \u201cGrowCalc Pro\u201d entitlement, managed through RevenueCat and the app stores. We do NOT collect or store your payment card details \u2014 billing is handled entirely by the Apple App Store / Google Play." },
      { label: "Device & usage data", text: "basic technical data (e.g., app version, error logs) used to keep the App reliable." },
    ],
  },
  {
    id: "how-we-use",
    title: "2. How We Use Your Information",
    items: [
      { text: "To provide the App's core features (calculations, logs, reminders, weather, backups)." },
      { text: "To authenticate you and keep your data private to your account." },
      { text: "To send local reminder notifications you schedule within the App." },
      { text: "To maintain, troubleshoot, and improve the App." },
    ],
  },
  {
    id: "third-party",
    title: "3. Third-Party Services",
    lead: "We use a small number of service providers to operate the App:",
    items: [
      { label: "Open-Meteo", text: "weather & soil-temperature forecasts (we send only approximate latitude/longitude derived from your ZIP code)." },
      { label: "Zippopotam.us", text: "converts your ZIP code to coordinates." },
      { label: "Google Sign-In", text: "optional authentication." },
      { label: "RevenueCat and the Apple App Store / Google Play", text: "subscription management and billing." },
    ],
  },
  {
    id: "data-sharing",
    title: "4. Data Sharing",
    paragraph:
      "We do NOT sell your personal information. We share data only with the service providers listed above as needed to run the App, or when required by law.",
  },
  {
    id: "retention",
    title: "5. Data Retention & Deletion",
    paragraph:
      "We retain your data while your account is active. You can delete your data at any time from Settings \u2192 Reset All Data, or permanently delete your entire account from Settings \u2192 Delete Account. You may also email us to request deletion.",
  },
  {
    id: "security",
    title: "6. Security",
    paragraph:
      "Passwords are stored using industry-standard hashing, and access to your data is restricted to your authenticated account. No method of transmission or storage is 100% secure, but we take reasonable measures to protect your information.",
  },
  {
    id: "children",
    title: "7. Children's Privacy",
    paragraph:
      "The App is not directed to children under 13, and we do not knowingly collect personal information from them.",
  },
  {
    id: "your-rights",
    title: "8. Your Rights",
    paragraph:
      "Depending on your location, you may have rights to access, correct, export, or delete your personal data. Contact us to exercise these rights.",
  },
  {
    id: "changes",
    title: "9. Changes to This Policy",
    paragraph:
      "We may update this Privacy Policy from time to time. We will update the effective date above and, where appropriate, notify you within the App.",
  },
];

export const CONTACT_EMAIL = "GrowCalcs@gmail.com";
